export const getDriveDisplayUrl = (fileId) => (
  `https://lh3.googleusercontent.com/d/${encodeURIComponent(fileId)}`
);
